export default function LogoMark({
    className = "h-6 w-6",
    bg = "#E31B23",
    fg = "#FFFFFF",
}) {
    return (
        <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
            {bg ? <rect width="64" height="64" fill={bg} /> : null}
            <path
                d="M22 27h20v19.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 22 46.5Z"
                fill={fg}
            />
            <path
                d="M26.5 26.5V21a5.5 5.5 0 0 1 11 0v5.5"
                stroke={fg}
                strokeWidth="3.5"
            />
        </svg>
    );
}
